<template>
	<div v-loading="fullscreenLoading">
	
		<div class="item-block">
			<div class="goods-head" style="padding: 5px auto;">
				<table>
					<tr>
						<td colspan="5">
							<div style="line-height: 42px;float: left;">
								<i class="store-icon iconfont iconmendian"></i>
								方案制作
							</div>
							<el-button type="success" style="margin: 0px auto; float: right;" class="el-button--primary" @click="generatePDF">立即生成方案</el-button>
						</td>
					</tr>
				</table>
			</div>
		</div>
		<div class="solution_content" id="contentToConvert" ref="contentToConvert">
			<div v-for="(siteItem, siteIndex) in orderPaymentData.shop_goods_list" :key="siteIndex">
				<div class="item-block">
					<div class="goods-list">
						<ul>
							<li v-for="(goodsItem, goodsIndex) in siteItem.goods_list" :key="goodsIndex">
								<div class="info_img">
									<router-link :to="{ path: '/sku-' + goodsItem.sku_id }" target="_blank">
										<!--$img(goodsItem.sku_image, { size: 'mid' })-->
										<img class="goods-img" :src="$img(goodsItem.sku_image, { size: '' })" @error="imageError(goodsIndex)" />
									</router-link>
								</div>
								<div class="info_content">
									<div class="info_tit">
										<h1>{{ goodsItem.sku_name }}</h1>
										<p class="desc ns-text-color" v-if="goodsItem.introduction">{{ goodsItem.introduction }}</p>
									</div>
									<div class="promotion-price">
										<dl class="item-line">
											<dt class="ns-text-color-gray">销售价</dt>
											<dd>
												<em class="yuan ns-text-color">¥</em>
												<span class="price ns-text-color">{{ goodsItem.discount_price }}</span>
											</dd>
										</dl>
										<dl class="item-line" v-if="goodsItem.promotion_type == 1 && discountTimeMachine.currentTime">
											<dt class="ns-text-color-gray">原价</dt>
											<dd>
												<em class="market-yuan">¥</em>
												<span class="market-price">{{ goodsItem.price }}</span>
											</dd>
										</dl>
										<dl class="item-line" v-if="goodsItem.member_price > 0">
											<dt class="ns-text-color-gray">会员价</dt>
											<dd>
												<em class="market-yuan">¥</em>
												<span class="member-price">{{ goodsItem.member_price }}</span>
											</dd>
										</dl>
										<dl class="item-line" v-if="goodsItem.market_price > 0">
											<dt class="ns-text-color-gray">市场价</dt>
											<dd>
												<em class="market-yuan">¥</em>
												<span class="market-price">{{ goodsItem.market_price }}</span>
											</dd>
										</dl>
										<dl class="item-line" v-if="goodsItem.is_virtual == 0">
											<dt>运费</dt>
											<dd>
												<i class="i-activity-flag ns-text-color ns-border-color" v-if="goodsItem.is_free_shipping">快递免邮</i>
												<i class="i-activity-flag ns-text-color ns-border-color" v-else>快递不免邮</i>
											</dd>
										</dl>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<!--结算-->
		<div class="item-block">
			<div  style="margin:0px auto;text-align: center; ">
				<el-button type="success" style="margin: 15px auto;" class="el-button--primary" @click="generatePDF">立即生成方案</el-button>
			</div>
			<div class="clear"></div>
		</div>

	</div>
</template>

<script>
	import PicZoom from 'vue-piczoom';
	import detail from './solution.js';
	export default {
		name: 'solution',
		components: {
			PicZoom
		},
		mixins: [detail]
	};
</script>

<style lang="scss" scoped>
	@import './solution.scss';
</style>
